export const emptyishToNull = (value: unknown) => {
  if (value === null || value === undefined) {
    return null;
  }

  if (typeof value === 'string') {
    const trimmed = value.trim();

    if (!trimmed) {
      return null;
    }

    if (trimmed.toLowerCase() === 'er') {
      return null;
    }
  }

  return value;
};
